// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/app/components/dialogs/components/PerksButton.module.css';
import {PREMIUM_PRODUCT_NAME} from '@app/features/app/config/I18nDisplayConstants';
import {Trans} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
export const PerksButton: React.FC<{
	onClick: () => void;
}> = observer(({onClick}) => (
	<button type="button" onClick={onClick} className={styles.link}>
		<Trans>{PREMIUM_PRODUCT_NAME} perks</Trans>
	</button>
));
